module.exports = __webpack_public_path__ + "img/a2.8a1fa089.jpg";